export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-100px.jpg.6fdb013b.webp";